import * as React from 'react';
import { mergeConfig } from '@websky/core/src/context';
import { withConfig } from '@websky/core/src/config-hoc';
import { render } from 'react-dom';
import SearchForm from './SearchForm';
import { config as defaultConfig } from '../../config';
export const init = (mount, config) => {
    const Component = withConfig(SearchForm, mergeConfig(defaultConfig, config));
    render(React.createElement(Component, null), mount);
};
